import { render, staticRenderFns } from "./CustomerAccountsTable.vue?vue&type=template&id=264d2cf4&scoped=true&"
import script from "./CustomerAccountsTable.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccountsTable.vue?vue&type=style&index=0&id=264d2cf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d2cf4",
  null
  
)

export default component.exports